
    import './styles.scoped.css';
    export default {
  "selected": "awsui_selected_1m93f_14fvl_5"
};
  